import { render, staticRenderFns } from "./FileCollectFormDialog.vue?vue&type=template&id=03c9dba5&scoped=true&"
import script from "./FileCollectFormDialog.vue?vue&type=script&lang=ts&"
export * from "./FileCollectFormDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FileCollectFormDialog.vue?vue&type=style&index=0&id=03c9dba5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c9dba5",
  null
  
)

export default component.exports